import {calculatorHTMItemValues} from '../../../shared/constants/calculator_htm_item.constant';
import {CalculatorOptions} from '../../../shared/classes/CalculatorOptions';

export type CalculatorInputFieldsKey = typeof CalculatorInputFields[number]['key'];

export type CalculatorInputFieldsType = Record<CalculatorInputFieldsKey, number | null>;

type CalculatorInputOptionType = Partial<Record<CalculatorInputFieldsKey, CalculatorOptions>>;

export const CalculatorInputFields = [
    {
      key: 'I8_average_number_of_procedures_per_day',
      label: 'Average number of Procedures per day',
      defaultValue: 5,
    },
    {
        key: 'I10_average_reimbursement_per_exams',
        label: 'Average reimbursement per exams ',
        defaultValue: 4700,
    },
    {
        key: 'E13_examination_mix_hight_price',
        label: 'Examination Mix - Hight Price',
        defaultValue: 7000,
    },
    {
        key: 'H13_examination_mix_hight_price_per_mix',
        label: 'Examination Mix - Hight Price (% mix)',
        defaultValue: 10,
    },
    {
        key: 'E14_examination_mix_medium_price',
        label: 'Examination Mix - Medium Price',
        defaultValue: 5000,
    },
    {
        key: 'H14_examination_mix_medium_price_per_mix',
        label: 'Examination Mix - Medium Price (% mix)',
        defaultValue: 40,
    },
    {
        key: 'E15_examination_mix_low_price_per_mix',
        label: 'Examination Mix - Low Price',
        defaultValue: 4000,
    },
    {
        key: 'H15_examination_mix_low_price_per_mix',
        label: 'Examination Mix - Low Price (% mix)',
        defaultValue: 50,
    },
    {
        key: 'I17_facility_opening_hours',
        label: 'Facility opening hours ',
        defaultValue: 8,
    },
    {
        key: 'I19_facility_opening_in_days_per_year',
        label: 'Facility opening in days per year',
        defaultValue: 300,
    },
    {
        key: 'I21_per_of_exams_rescheduled_after_an_event',
        label: '% of Exams rescheduled after an event',
        defaultValue: 80,
    },
    {
        key: 'R8_#_of_radiologist',
        label: '# of Radiologist(s)',
        defaultValue: 1,
    },
    {
        key: 'R10_#_of_radiographer',
        label: '# of Radiographer(s)',
        defaultValue: 2,
    },
    {
        key: 'R14_inhouse_engineer_cost_per_hour',
        label: 'InHouse Engineer cost per hour',
        defaultValue: 200,
    },
    {
        key: 'R16_rate_HTM_org_performance',
        label: 'How would you rate your HTM org performance',
        defaultValue: calculatorHTMItemValues[0]['code'],
    },
    {
        key: 'AA8_admin_fee_per_rescheduled_patient',
        label: 'Admin fee per rescheduled patient',
        defaultValue: 30,
    },
    {
        key: 'AA10_radiographerwages_per_hour',
        label: 'Radiographer Wages per hour',
        defaultValue: 100,
    },
    {
        key: 'AA12_radiologistwages_per_hour',
        label: 'Radiologist Wages per hour',
        defaultValue: 250,
    },
    {
        key: 'AA14_doctor_wages_per_hour',
        label: 'Doctor Wages per hour',
        defaultValue: 250,
    },
    {
        key: 'AA17_radiographer_overtime_wages_in_per',
        label: 'Radiographer Overtime Wages in %',
        defaultValue: 25,
    },
    {
        key: 'AA19_radiologist_overtime_wages_in_per',
        label: 'Radiologist Overtime Wages in %',
        defaultValue: 25,
    },
    {
        key: 'K27_avg_transfer_rate_when_system_is_down',
        label: 'Avg transfer rate when system is down in %',
        defaultValue: 10,
    },
    {
        key: 'K29_transportation_fee_for_a_patient_transfer',
        label: 'Transportation fee for a patient transfer',
        defaultValue: 1000,
    },
    {
        key: 'K31_avg_transfer_time_including_exam_time_in_hours',
        label: 'Avg transfer time including exam time in hours',
        defaultValue: 4,
    },
    {
        key: 'K33_examination_fee',
        label: 'Examination fee',
        defaultValue: 4700,
    },
    {
        key: 'K35_#_of_doctor_clinician',
        label: '# of doctor(s) /clinician(s)',
        defaultValue: 2,
    },
    {
        key: 'K37_doctor_clinician_wages_per_hours',
        label: 'Doctor/Clinician wages per hours',
        defaultValue: 200,
    },
    {
        key: 'K39_#_of_nurses',
        label: '# of nurses',
        defaultValue: 1,
    },
    {
        key: 'K41_nurses_wages_per_hour',
        label: 'Nurses wages per hour',
        defaultValue: 100,
    },
    {
        key: 'V27_avg_surgeries_requiring_diagnostic_imaging_prior_to_surgery',
        label: 'Avg Surgeries requiring diagnostic imaging prior to surgery in %',
        defaultValue: 5,
    },
    {
        key: 'V29_#_of_surgeon',
        label: '# of Surgeon(s)',
        defaultValue: 1,
    },
    {
        key: 'V31_surgeon_avg_wages_per_hour',
        label: 'Surgeon avg wages per hour',
        defaultValue: 350,
    },
    {
        key: 'V33_#_of_doctor_clinician',
        label: '# of doctor(s) /clinician(s)',
        defaultValue: 1,
    },
    {
        key: 'V35_doctor_clinician_avg_wages_per_hour',
        label: 'Doctor(s)/Clinician(s) avg wages per hour',
        defaultValue: 250,
    },
    {
        key: 'V37_#_of_nurses',
        label: '# of nurses',
        defaultValue: 3,
    },
    {
        key: 'V39_nurses_wages_per_hour',
        label: 'Nurses wages per hour',
        defaultValue: 100,
    },
    {
        key: 'V41_avg_surgery_lenght_in_hours',
        label: 'Avg Surgery lenght in hours',
        defaultValue: 6,
    },
    {
        key: 'V43_avg_patient_intensive_care_lenght_in_hours',
        label: 'Avg Patient Intensive Care lenght in hours',
        defaultValue: 3.5,
    },
    {
        key: 'V45_avg_cost_per_hour_in_the_intensive_care_dept',
        label: 'Avg Cost per hour in the intensive care dept ',
        defaultValue: 1000,
    }
] as const;

export const CalculatorInputOptions: CalculatorInputOptionType = {
    I10_average_reimbursement_per_exams: {
        displayCurrency: true,
    },
    E13_examination_mix_hight_price: {
        displayCurrency: true,
    },
    E14_examination_mix_medium_price: {
        displayCurrency: true,
    },
    E15_examination_mix_low_price_per_mix: {
        displayCurrency: true,
    },
    H13_examination_mix_hight_price_per_mix: {
        formatValueFunction: (value: number) => {
            return (value || 0) / 100;
        },
    },
    H14_examination_mix_medium_price_per_mix: {
        formatValueFunction: (value: number) => {
            return (value || 0) / 100;
        },
    },
    H15_examination_mix_low_price_per_mix: {
        formatValueFunction: (value: number) => {
            return (value || 0) / 100;
        },
    },
    I21_per_of_exams_rescheduled_after_an_event: {
        formatValueFunction: (value: number) => {
            return (value || 0) / 100;
        },
    },
    K27_avg_transfer_rate_when_system_is_down: {
        formatValueFunction: (value: number) => {
            return (value || 0) / 100;
        },
    },
    K37_doctor_clinician_wages_per_hours: {
        displayCurrency: true,
    },
    K41_nurses_wages_per_hour: {
        displayCurrency: true,
    },
    R14_inhouse_engineer_cost_per_hour: {
        displayCurrency: true,
        isHTMMode: true
    },
    R16_rate_HTM_org_performance: {
        valueList: [
            ...calculatorHTMItemValues
        ],
        isHTMMode: true
    },
    AA10_radiographerwages_per_hour: {
        displayCurrency: true,
    },
    AA12_radiologistwages_per_hour: {
        displayCurrency: true,
    },
    AA14_doctor_wages_per_hour: {
        displayCurrency: true,
    },
    AA17_radiographer_overtime_wages_in_per: {
        formatValueFunction: (value: number) => {
            return (value || 0) / 100;
        },
    },
    AA19_radiologist_overtime_wages_in_per: {
        formatValueFunction: (value: number) => {
            return (value || 0) / 100;
        },
    },
    V27_avg_surgeries_requiring_diagnostic_imaging_prior_to_surgery: {
        formatValueFunction: (value: number) => {
            return (value || 0) / 100;
        },
    },
    V31_surgeon_avg_wages_per_hour: {
        displayCurrency: true,
    },
    V35_doctor_clinician_avg_wages_per_hour: {
        displayCurrency: true,
    },
    V39_nurses_wages_per_hour: {
        displayCurrency: true,
    },
    V45_avg_cost_per_hour_in_the_intensive_care_dept: {
        displayCurrency: true,
    },
}

export const CalculatorInputFieldsValues: CalculatorInputFieldsType = CalculatorInputFields.reduce((prev, curr) => {
    return {
        ...(prev || {}),
        [curr.key]: curr.defaultValue
    };
}, {}) as CalculatorInputFieldsType;
